import Vue from "vue";
import moment from "moment";
Vue.filter("timeTransform", (input, string = "hh:mm:ss") => {
  return moment(input).format(string);
});